import { render, staticRenderFns } from "./HelpLinkSetting.vue?vue&type=template&id=1fdfd9d2&scoped=true"
import script from "./HelpLinkSetting.vue?vue&type=script&lang=js"
export * from "./HelpLinkSetting.vue?vue&type=script&lang=js"
import style0 from "./HelpLinkSetting.vue?vue&type=style&index=0&id=1fdfd9d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fdfd9d2",
  null
  
)

export default component.exports